import React,{useState} from 'react'

type HelloReactProps = {
    nome: string
}

const HelloReact = (props:HelloReactProps) => {

    const [nome,setNome] = useState(props.nome)

    return (
        <div>
            <div>
                Diga olá para o React!
            </div>
            <div>
                <input onChange={e => {
                    setNome(e.target.value)
                }} placeholder="Digite seu nome"/>
            </div>

            {nome && <div>
                Olá {nome}
            </div>}
        </div>
    )
}

export {
    HelloReact,
    HelloReactProps
}



